import { useEntitiesContextsQueryState } from "@hooks/useEntitiesContexts";

export function useTransactionsPageReady() {
    const entitiesContextsQueryState = useEntitiesContextsQueryState();
    return entitiesContextsQueryState?.status === "success";
}
